module.exports = __webpack_public_path__ + "static/media/al ghani.08475457.png";